import React from "react"
import moment from "moment"
import { withTranslation, WithTranslation, Trans } from "react-i18next"
import { observer, inject } from "mobx-react"
import Store from "../stores/Store"
import Grid from "@material-ui/core/Grid"
import Hidden from "@material-ui/core/Hidden"
import { BookingItem } from "../records/Booking"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableHead from "@material-ui/core/TableHead"
import TableFooter from "@material-ui/core/TableFooter"
import TableRow from "@material-ui/core/TableRow"
import Typography from "@material-ui/core/Typography"

interface BookingDetailsProps extends WithTranslation {
    store?: Store
}

@inject("store")
@observer
class BookingDetails extends React.Component<BookingDetailsProps> {
    render () {
        return (
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Typography variant="overline" color="textSecondary">{this.props.t("Check-in")}</Typography>
                            <Typography variant="subtitle1">{moment(this.props.store!.checkIn).format("Y-MM-DD")}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="overline" color="textSecondary">{this.props.t("Check-out")}</Typography>
                            <Typography variant="subtitle1">{moment(this.props.store!.checkOut).format("Y-MM-DD")}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="overline" color="textSecondary">{this.props.t("Guests")}</Typography>
                            <Typography variant="subtitle1">{this.props.store!.guests}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{this.props.t("Room")}</TableCell>
                                <TableCell align="right">{this.props.t("Beds")}</TableCell>
                                <TableCell align="right">{this.props.t("Price")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.props.store!.selectedRooms.map((item: BookingItem) => (
                                <TableRow key={item.id}>
                                    <TableCell>{item.name}</TableCell>
                                    <TableCell align="right">{item.beds}</TableCell>
                                    <TableCell align="right">{item.price.toFixed(2)}&nbsp;€</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell>
                                    <Typography variant="h6">
                                        {this.props.t("Total")}
                                    </Typography>
                                </TableCell>
                                <TableCell align="right">
                                    <Hidden xsDown>
                                        <Typography variant="h6">
                                            {this.props.store!.totalBeds}
                                        </Typography>
                                    </Hidden>
                                </TableCell>
                                <TableCell align="right">
                                    <Typography variant="h6">
                                        {this.props.store!.sumPrice.toFixed(2)}&nbsp;€
                                    </Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={2}>
                                    <Trans i18nKey="Payment" count={this.props.store!.feePercent}>
                                        Total payment to confirm reservation
                                    </Trans>
                                </TableCell>
                                <TableCell align="right">{this.props.store!.payPrice.toFixed(2)}&nbsp;€</TableCell>
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Grid>
            </Grid>
        )
    }
}

export default withTranslation()(BookingDetails)
